import { render, staticRenderFns } from "./mobileInfoMsg.vue?vue&type=template&id=d39fef7a&scoped=true&"
import script from "./mobileInfoMsg.vue?vue&type=script&lang=js&"
export * from "./mobileInfoMsg.vue?vue&type=script&lang=js&"
import style0 from "./mobileInfoMsg.vue?vue&type=style&index=0&id=d39fef7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39fef7a",
  null
  
)

export default component.exports